export async function redelegateStake(params) {
    const { spaceDapp, smartAccount, fnArgs } = params;
    const { depositIds, delegatee, operatorAddress, signer } = fnArgs;
    if (!spaceDapp?.config.addresses.baseRegistry) {
        throw new Error('spaceDapp.config.addresses.baseRegistry is required for restake operation.');
    }
    const baseRegistryAddress = spaceDapp.config.addresses.baseRegistry;
    if (!baseRegistryAddress) {
        throw new Error('Rewards address is required for restake operation.');
    }
    const toAddress = [];
    const callData = [];
    // Only include delegation operation if operatorAddress is provided
    if (operatorAddress) {
        // Create call data for space delegation
        const addSpaceDelegationCallData = spaceDapp.baseRegistry.spaceDelegation.interface.encodeFunctionData('addSpaceDelegation', [delegatee, operatorAddress]);
        toAddress.push(baseRegistryAddress);
        callData.push(addSpaceDelegationCallData);
    }
    // Create call data for redelegating each deposit
    const redelegateCallDataArray = depositIds.map((depositId) => spaceDapp.baseRegistry.rewardsDistributionV2.interface.encodeFunctionData('redelegate', [
        depositId,
        delegatee,
    ]));
    // Add redelegate operations
    const redelegateAddressArray = Array.from({ length: depositIds.length }, () => baseRegistryAddress);
    toAddress.push(...redelegateAddressArray);
    callData.push(...redelegateCallDataArray);
    return smartAccount.sendUserOp({
        toAddress,
        callData,
        signer,
        spaceId: delegatee,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
